import { render, staticRenderFns } from "./HistoryTimelineCard.vue?vue&type=template&id=223128b4&scoped=true&"
import script from "./HistoryTimelineCard.vue?vue&type=script&lang=js&"
export * from "./HistoryTimelineCard.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTimelineCard.vue?vue&type=style&index=0&id=223128b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223128b4",
  null
  
)

export default component.exports